import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=0732663a&scoped=true&"
import script from "./Sso.vue?vue&type=script&lang=ts&"
export * from "./Sso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732663a",
  null
  
)

export default component.exports